export default "__VITE_ASSET__CB0H$btM__"